module.exports = __webpack_public_path__ + "img/baseInfo_header3.937c2044.svg";